// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"d86306e6","453":"d855a71b","887":"52983347"}[chunkId] + ".chunk.js";
};